import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStorageHardLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		isInCollection,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	return (
		!isInCollection &&
		product === 'jira' &&
		edition === 'free' &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB
	);
}
